// Mix & Match 2.0 – Redesign (Sticky-Leiste mit Stufen-Progressbar, gruppierte Box, robuster Warenkorb-Klick).
// Basiert auf mix-match-2-0.js; Rabattlogik und Selling Plans sind unverändert. Produkt-Pop-up: ?view=mm-popup.
// Tracking: Events mm_* (siehe track()) und Cart-Properties _mm_box / _mm_version für die Auswertung pro Box und Seitenversion.
// Preisformat je Währung: EUR „€12,90“, sonst wie das Shop-Format (z. B. Schweiz „CHF 12.90“)
var MM_CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
var mmMoney = cents => (MM_CURRENCY === 'EUR'
  ? `€${(cents / 100).toFixed(2).replace('.', ',')}`
  : `${MM_CURRENCY} ${(cents / 100).toFixed(2)}`);
(() => {
  const root = document.querySelector('[data-mm-version="2"]');
  if (!root) return;

  const atcBtn = root.querySelector('#mixAndMatchATC');
  if (!atcBtn) return;

  // ── DOM refs ────────────────────────────────────────────────────────────────
  const el = {
    atcBtn,
    bar:           root.querySelector('[data-mmr-bar]'),
    sheet:         root.querySelector('[data-mmr-sheet]'),
    sheetToggle:   root.querySelector('[data-mmr-sheet-toggle]'),
    lines:         root.querySelector('[data-mmr-lines]'),
    empty:         root.querySelector('[data-mmr-empty]'),
    saving:        root.querySelector('[data-mmr-saving]'),
    selectedCount: root.querySelector('[data-mm-selected]'),
    message:       root.querySelector('[data-mmr-msg]'),
    progress:      root.querySelector('[data-mmr-progress]'),
    pips:          root.querySelector('[data-mmr-pips]'),
    marks:         root.querySelector('[data-mmr-marks]'),
    tiers:         root.querySelector('[data-mmr-tiers]'),
    tierNote:      root.querySelector('[data-mmr-tier-note]'),
    atcLabel:      root.querySelector('[data-mmr-atc-label]'),
    atcPrice:      root.querySelector('[data-mmr-atc-price]'),
    atcFull:       root.querySelector('[data-mmr-full]'),
    atcTotal:      root.querySelector('[data-mmr-total]'),
    error:         root.querySelector('[data-mmr-error]'),
    popup:         document.querySelector('[data-mm-popup="2"]'),
    popupContent:  document.querySelector('[data-mm-popup="2"] .MixAndMatchProduct--Popup-Content'),
    subToggle:     root.querySelector('#mmSubscriptionToggle'),
    subFreqSelect: root.querySelector('[data-mm-freq-select]'),
  };

  const mmrCopy = JSON.parse(document.querySelector('[data-mmr-config]')?.textContent || '{}');
  const mmrNum = (key, fallback) => {
    const value = Number(mmrCopy[key]);
    return Number.isFinite(value) ? value : fallback;
  };
  const mmrText = (key, fallback) => (typeof mmrCopy[key] === 'string' && mmrCopy[key] !== '' ? mmrCopy[key] : fallback);
  const mmrFill = (template, vars) => Object.entries(vars).reduce(
    (text, [key, value]) => text.replaceAll(`[${key}]`, value),
    template
  );

  // ── Tracking: eigene Events für die Auswertung ───────────────────────────
  // Gehen an Shopify (Kunden-Events) und an den dataLayer. GTM/GA4 leitet sie nur mit Einwilligung weiter.
  const TRACK_BASE = {
    mm_version: mmrText('trackVersion', 'v2'),
    mm_template: mmrText('template', ''),
    mm_collection_id: String(mmrCopy.collectionId || ''),
  };
  const VERSION_LABEL = TRACK_BASE.mm_template ? `${TRACK_BASE.mm_version} · ${TRACK_BASE.mm_template}` : TRACK_BASE.mm_version;
  let changeSource = 'card'; // wer ändert gerade die Mengen: card, popup, sheet, box, clear, cart
  function withSource(source, fn) {
    const before = changeSource;
    changeSource = source;
    try { fn(); } finally { changeSource = before; }
  }
  function track(event, data = {}) {
    const params = { ...TRACK_BASE, ...data };
    try { window.Shopify?.analytics?.publish?.(event, params); } catch (err) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ mm: null });
      window.dataLayer.push({ event, mm: params });
    } catch (err) {}
  }

  const SHIPPING_LABEL = mmrText('shippingLabel', 'Gratis-Versand');
  const BEST_LABEL     = mmrText('bestLabel', 'Bestpreis');

  const configTiers = Array.isArray(mmrCopy.tiers) ? mmrCopy.tiers : [];
  const tiersFor = key => {
    const source = configTiers.length ? configTiers : [
      { at: mmrNum(key === 'sub' ? 'sub1At' : 'once1At', key === 'sub' ? 1 : 0), [key]: mmrNum(key === 'sub' ? 'sub1Pct' : 'once1Pct', key === 'sub' ? 5 : 0) },
      { at: mmrNum(key === 'sub' ? 'sub2At' : 'once2At', 12), [key]: mmrNum(key === 'sub' ? 'sub2Pct' : 'once2Pct', key === 'sub' ? 10 : 5) },
      { at: mmrNum(key === 'sub' ? 'sub3At' : 'once3At', 18), [key]: mmrNum(key === 'sub' ? 'sub3Pct' : 'once3Pct', key === 'sub' ? 15 : 10) },
    ];
    return source
      .map(tier => ({ at: Number(tier.at) || 0, pct: Number(tier[key]) || 0 }))
      .filter(tier => tier.at > 0 && tier.pct > 0)
      .sort((a, b) => a.at - b.at);
  };

  const PLANS = {
    sub: { shippingAt: mmrNum('subShippingAt', 10), tiers: tiersFor('sub') },
    once: { shippingAt: mmrNum('onceShippingAt', 10), tiers: tiersFor('once') },
  };

  const planOf = subscription => (subscription ? PLANS.sub : PLANS.once);
  const pricedTiers = subscription => planOf(subscription).tiers.filter(tier => tier.pct > 0 && tier.at > 0);
  const barMilestones = subscription => {
    const plan = planOf(subscription);
    const items = [];
    if (plan.shippingAt > 0) items.push({ at: plan.shippingAt, kind: 'shipping', label: SHIPPING_LABEL });
    pricedTiers(subscription).forEach(tier => {
      if (tier.at <= 1) return;
      items.push({ at: tier.at, kind: 'discount', pct: tier.pct, label: `−${tier.pct} %` });
    });
    items.sort((a, b) => a.at - b.at);
    return items.reduce((merged, item) => {
      const last = merged[merged.length - 1];
      if (last && last.at === item.at) {
        last.label = `${last.label} · ${item.label}`;
        if (item.kind === 'discount') last.pct = item.pct;
      } else {
        merged.push({ ...item });
      }
      return merged;
    }, []);
  };
  const topTier = subscription => pricedTiers(subscription).reduce((top, tier) => (tier.at > top.at ? tier : top), { at: 0, pct: 0 });
  const MAX_COUNT = Math.max(1, ...barMilestones(true).map(mark => mark.at), ...barMilestones(false).map(mark => mark.at));

  const CHECK_SVG = '<svg class="MMR-Check" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  const PLUS_SVG  = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  const MINUS_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';

  // ── Observe programmatic value changes on an input ────────────────────────
  function observeInputValue(input, callback) {
    const proto = Object.getPrototypeOf(input);
    if (!proto.hasOwnProperty('value')) return;
    const descriptor = Object.getOwnPropertyDescriptor(proto, 'value');
    Object.defineProperty(input, 'value', {
      get() { return descriptor.get.call(this); },
      set(next) {
        const prev = descriptor.get.call(this);
        descriptor.set.call(this, next);
        callback(prev, descriptor.get.call(this));
      },
    });
  }

  const productTitle = item => item?.querySelector('.ProductItem__Title')?.textContent.trim() ?? '';

  // ── Quantity +/- buttons ──────────────────────────────────────────────────
  function syncQuickAddState(field) {
    const selector = field.closest('.product-quantity-selector');
    if (!selector) return;
    const qty = parseInt(field.value, 10);
    const btn = selector.querySelector('.ProductItem-QuickAdd-mm');
    const qs  = selector.querySelector('.QuantitySelector');
    if (qty > 0) {
      if (btn) btn.style.display = 'none';
      if (qs)  qs.style.display  = '';
    } else {
      if (btn) btn.style.display = '';
      if (qs)  qs.style.display  = 'none';
    }
  }

  // Screenreader-Labels pro Gericht statt 17× „Hinzufügen“
  function labelQuantityButtons(scope = root) {
    scope.querySelectorAll('.product-quantity-selector').forEach(selector => {
      const name = productTitle(selector.closest('.ProductItem')) || 'Gericht';
      selector.querySelector('[data-action="quick-add"]')?.setAttribute('aria-label', `${name} hinzufügen`);
      selector.querySelector('[data-action="increase-quantity"]')?.setAttribute('aria-label', `${name}: eins mehr`);
      selector.querySelector('[data-action="decrease-quantity-null"]')?.setAttribute('aria-label', `${name}: eins weniger`);
    });
  }

  function initQuantityButtons(scope = root) {
    scope.querySelectorAll('[data-action="decrease-quantity-null"]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const field = e.currentTarget.closest('.QuantitySelector').querySelector('.QuantitySelector__CurrentQuantity');
        field.value = Math.max(parseInt(field.value, 10) - 1, 0);
        syncQuickAddState(field);
      });
    });

    scope.querySelectorAll('[data-action="increase-quantity"]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const field = e.currentTarget.closest('.QuantitySelector').querySelector('.QuantitySelector__CurrentQuantity');
        field.value = parseInt(field.value, 10) + 1;
        syncQuickAddState(field);
      });
    });

    scope.querySelectorAll('[data-action="quick-add"]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const selector = e.currentTarget.closest('.product-quantity-selector');
        const field = selector.querySelector('.QuantitySelector__CurrentQuantity');
        field.value = 1;
        syncQuickAddState(field);
      });
    });
  }

  // ── Produkt-Pop-up (Bottom-Sheet, ?view=mm-popup) ─────────────────────────
  // core wird in initCore gesetzt: Zugriff auf Menge, Preise und Rabattstufe des Builders
  let core = null;
  let popupItem = null;
  let popupTrigger = null;
  let popupRefresh = null;

  function initPopupReviews(sku) {
    // an empty div#ReviewsWidget makes the bare name resolve to that element, so check for the constructor
    if (typeof ReviewsWidget !== 'function') return;
    new ReviewsWidget('.MixAndMatchProduct--Popup-Content #ReviewsWidget', {
      store: 'www.loewenanteil.com',
      widget: 'polaris',
      options: {
        types: 'product_review, questions',
        lang: 'de',
        layout: '',
        per_page: 5,
        product_review: { sku, hide_if_no_results: true },
        questions: { hide_if_no_results: false, enable_ask_question: true, show_dates: true },
        header: {
          enable_summary: true, enable_ratings: true, enable_attributes: false,
          enable_image_gallery: false, enable_percent_recommended: false,
          enable_write_review: false, enable_ask_question: true, enable_sub_header: true,
        },
        filtering: {
          enable: true, enable_text_search: false, enable_sorting: true,
          enable_overall_rating_filter: true, enable_ratings_filters: false,
          enable_attributes_filters: false,
        },
        reviews: {
          enable_avatar: false, enable_reviewer_name: true, enable_reviewer_address: false,
          reviewer_address_format: 'city, country', enable_verified_badge: true,
          enable_reviewer_recommends: false, enable_attributes: false, enable_product_name: false,
          enable_review_title: false, enable_replies: undefined, enable_images: false,
          enable_ratings: false, enable_share: false, enable_helpful_vote: false,
          enable_helpful_display: false, enable_report: false, enable_date: true,
        },
        text: { 'Verified Customer': 'Verified Customer' },
      },
      translations: { 'Verified Customer': 'Verifizierter Käufer' },
      styles: {
        '--base-font-size': '16px',
        '--common-button-font-family': 'inherit', '--common-button-font-size': '16px',
        '--common-button-font-weight': '500', '--common-button-letter-spacing': '0',
        '--common-button-text-transform': 'none', '--common-button-vertical-padding': '10px',
        '--common-button-horizontal-padding': '20px', '--common-button-border-width': '2px',
        '--common-button-border-radius': '0px',
        '--primary-button-bg-color': '#0E1311', '--primary-button-border-color': '#0E1311',
        '--primary-button-text-color': '#ffffff',
        '--secondary-button-bg-color': 'transparent', '--secondary-button-border-color': '#0E1311',
        '--secondary-button-text-color': '#0E1311',
        '--common-star-color': '#fbcd0a', '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
        '--medium-star-size': '22px', '--small-star-size': '19px',
        '--heading-text-color': '#0E1311', '--heading-text-font-weight': '600',
        '--heading-text-font-family': 'inherit', '--heading-text-line-height': '1.4',
        '--heading-text-letter-spacing': '0', '--heading-text-transform': 'none',
        '--body-text-color': '#0E1311', '--body-text-font-weight': '400',
        '--body-text-font-family': 'inherit', '--body-text-line-height': '1.4',
        '--body-text-letter-spacing': '0', '--body-text-transform': 'none',
        '--photo-video-thumbnail-size': '80px', '--photo-video-thumbnail-border-radius': '0px',
      },
    });
  }

  const visibleItems = () => Array.from(root.querySelectorAll('.CollectionMixAndMatch .Grid__Cell'))
    .filter(cell => cell.style.display !== 'none')
    .map(cell => cell.querySelector('.ProductItem'))
    .filter(Boolean);

  const itemInput = item => item?.querySelector('.QuantitySelector__CurrentQuantity');
  const itemImage = item => {
    const img = item?.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    return img ? (img.currentSrc || (img.dataset.src ? img.dataset.src.replace('{width}', '300') : '')) : '';
  };

  function setItemQty(item, qty) {
    const input = itemInput(item);
    if (!input) return;
    input.value = Math.max(0, qty);
    syncQuickAddState(input);
  }

  function closePopup() {
    if (!el.popup) return;
    el.popup.setAttribute('aria-hidden', 'true');
    el.popupContent.replaceChildren();
    document.documentElement.classList.remove('MMR-NoScroll');
    popupItem = null;
    popupRefresh = null;
    if (popupTrigger && document.contains(popupTrigger)) popupTrigger.focus({ preventScroll: true });
  }

  async function openPopup(item, trigger) {
    const link = item?.querySelector('.ProductItem__PopUp');
    if (!link || !el.popup) return;
    popupItem = item;
    if (trigger) popupTrigger = trigger;
    track('mm_popup_open', { dish: productTitle(item), via: trigger ? 'card' : 'browse' });
    const url = link.getAttribute('href').replace('view=ajax', 'view=mm-popup');

    el.popup.classList.add('MMR-Popup');
    el.popup.setAttribute('aria-hidden', 'false');
    el.popup.setAttribute('role', 'dialog');
    el.popup.setAttribute('aria-modal', 'true');
    document.documentElement.classList.add('MMR-NoScroll');
    el.popupContent.classList.add('is-loading');

    try {
      const html = await fetch(url).then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      });
      if (popupItem !== item) return; // inzwischen anderes Gericht geöffnet
      el.popupContent.innerHTML = html;
      el.popupContent.classList.remove('is-loading');
      wirePopup(item);
    } catch (err) {
      console.error('[MixMatch] Failed to load product popup:', err);
      el.popupContent.classList.remove('is-loading');
      el.popupContent.innerHTML = '<div class="MMP MMP--Error"><p>Das Gericht konnte gerade nicht geladen werden.</p><button type="button" class="MMP__Done" data-mmp-close>Schließen</button></div>';
      el.popupContent.querySelector('[data-mmp-close]')?.addEventListener('click', closePopup);
    }
  }

  function wirePopup(item) {
    const p = el.popupContent.querySelector('[data-mmp]');
    if (!p || !core) return;
    const $ = sel => p.querySelector(sel);
    const sku = itemInput(item)?.dataset.sku;
    const name = productTitle(item);
    const popupSet = (target, qty) => withSource('popup', () => setItemQty(target, qty));

    // Schließen
    p.querySelectorAll('[data-mmp-close]').forEach(btn => btn.addEventListener('click', closePopup));
    $('.MMP__Close')?.focus({ preventScroll: true });

    // Durchblättern
    const list = visibleItems();
    const idx = list.indexOf(item);
    const prev = idx > 0 ? list[idx - 1] : null;
    const next = idx > -1 && idx < list.length - 1 ? list[idx + 1] : null;
    $('[data-mmp-pos]').textContent = idx > -1 ? `${idx + 1} von ${list.length}` : '';
    [['[data-mmp-prev]', '[data-mmp-prev-name]', prev], ['[data-mmp-next]', '[data-mmp-next-name]', next]].forEach(([btnSel, nameSel, target]) => {
      const btn = $(btnSel);
      if (!btn) return;
      if (!target) { btn.hidden = true; return; }
      const targetName = productTitle(target);
      $(nameSel).textContent = targetName;
      btn.setAttribute('aria-label', `${btnSel.includes('prev') ? 'Vorheriges' : 'Nächstes'} Gericht: ${targetName}`);
      btn.addEventListener('click', () => openPopup(target));
    });

    // Galerie
    const slides = $('[data-mmp-slides]');
    const dots = Array.from(p.querySelectorAll('[data-mmp-dot]'));
    if (slides && dots.length) {
      dots.forEach(dot => dot.addEventListener('click', () => {
        slides.scrollTo({ left: Number(dot.dataset.mmpDot) * slides.clientWidth, behavior: 'smooth' });
      }));
      slides.addEventListener('scroll', () => {
        const active = Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
      }, { passive: true });
    }

    // Mehr lesen
    const more = $('[data-mmp-more]');
    const moreBtn = $('[data-mmp-more-toggle]');
    moreBtn?.addEventListener('click', () => {
      const open = more.hidden;
      more.hidden = !open;
      moreBtn.textContent = open ? 'Weniger' : 'Mehr lesen';
      moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // Zu den Bewertungen
    $('[data-mmp-to-reviews]')?.addEventListener('click', e => {
      e.preventDefault();
      p.querySelector('#mmpReviews')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Nährstoff-Balken, Sterne, Reviews (wie bisher)
    if (typeof initPorductBars === 'function') { try { initPorductBars(); } catch (err) {} }
    if (typeof ratingSnippet !== 'undefined') {
      try {
        ratingSnippet('MixAndMatchProduct--Popup-Content .ruk_rating_snippet', {
          store: 'www.loewenanteil.com', color: '#fbcd0a', linebreak: false, snippetPopup: false,
        });
      } catch (err) {
        console.warn('[MixMatch] Rating snippet failed:', err);
      }
    }
    const reviewsSkuEl = p.querySelector('#reviews-sku');
    if (reviewsSkuEl) {
      const loadPolaris = window.__reviewsioLoadPolaris || function (fn) { setTimeout(fn, 0); };
      loadPolaris(function () {
        try { initPopupReviews(reviewsSkuEl.dataset.sku); } catch (err) { console.warn('[MixMatch] Reviews widget failed:', err); }
      });
    }

    // „Passt gut in deine Box“: bis zu 3 weitere Gerichte, die noch nicht in der Box sind
    const crossWrap = $('[data-mmp-cross]');
    const crossGrid = $('[data-mmp-cross-grid]');
    const all = Array.from(root.querySelectorAll('.CollectionMixAndMatch .ProductItem'));
    const start = Math.max(all.indexOf(item), 0);
    const crossItems = [];
    for (let i = 1; i < all.length && crossItems.length < 3; i++) {
      const cand = all[(start + i) % all.length];
      if (cand !== item && !(parseInt(itemInput(cand)?.value, 10) > 0)) crossItems.push(cand);
    }
    const crossButtons = [];
    if (crossWrap && crossGrid && crossItems.length) {
      crossItems.forEach(cand => {
        const card = document.createElement('div');
        card.className = 'MMP__CrossItem';
        const img = document.createElement('img');
        img.src = itemImage(cand);
        img.alt = '';
        img.loading = 'lazy';
        const label = document.createElement('div');
        label.className = 'MMP__CrossName';
        label.textContent = productTitle(cand);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'MMP__CrossBtn';
        btn.setAttribute('aria-label', `${productTitle(cand)} zur Box hinzufügen`);
        btn.addEventListener('click', () => popupSet(cand, (parseInt(itemInput(cand)?.value, 10) || 0) + 1));
        card.append(img, label, btn);
        crossGrid.appendChild(card);
        crossButtons.push([cand, btn]);
      });
      crossWrap.hidden = false;
    }

    // Menge
    const qtyNow = () => parseInt(itemInput(item)?.value, 10) || 0;
    $('[data-mmp-add]')?.addEventListener('click', () => popupSet(item, qtyNow() + 1));
    $('[data-mmp-plus]')?.addEventListener('click', () => popupSet(item, qtyNow() + 1));
    $('[data-mmp-minus]')?.addEventListener('click', () => popupSet(item, qtyNow() - 1));

    // Fortschritt im Pop-up
    const pipsWrap = $('[data-mmp-pips]');
    const pips = [];
    if (pipsWrap) {
      for (let i = 1; i <= MAX_COUNT; i++) {
        const pip = document.createElement('span');
        pipsWrap.appendChild(pip);
        pips.push(pip);
      }
    }
    const portions = parseInt(p.dataset.portions, 10) || 0;

    popupRefresh = () => {
      const qty = qtyNow();
      const n = core.count();
      const price = core.price(sku);
      const unit = Math.ceil(price * core.cardFactor(n));
      const toEuro = cents => mmMoney(cents);

      $('[data-mmp-unit]').textContent = toEuro(unit);
      const full = $('[data-mmp-full]');
      full.textContent = toEuro(price);
      full.hidden = unit >= price;
      $('[data-mmp-portion]').textContent = portions > 1 ? ` · ${toEuro(Math.ceil(unit / portions))} pro Portion` : '';
      const hintList = subscription => pricedTiers(subscription)
        .filter(tier => tier.at > 1)
        .map(tier => `ab ${tier.at} Gerichten −${tier.pct} %`)
        .join(', ');
      const sentence = text => text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
      const onceHint = hintList(false);
      const subHint = hintList(true);
      $('[data-mmp-hint]').textContent = core.isSub()
        ? `Preis inkl. Lieferplan-Vorteil. ${sentence(subHint)}.`
        : `${sentence(onceHint)}. Mit Lieferplan: ${subHint}.`;
      $('[data-mmp-add-price]').textContent = toEuro(unit);

      const inBox = $('[data-mmp-inbox]');
      inBox.hidden = qty === 0;
      inBox.textContent = `${qty}× in deiner Box`;
      $('[data-mmp-add]').hidden = qty > 0;
      $('[data-mmp-stepper]').hidden = qty === 0;
      $('[data-mmp-qty]').textContent = qty;

      $('[data-mmp-count]').textContent = `${n} ${n === 1 ? 'Gericht' : 'Gerichte'}`;
      const popupMarks = barMilestones(core.isSub());
      const popupGoal = popupMarks.find(mark => mark.at > n);
      const goalEl = $('[data-mmp-goal]');
      goalEl.textContent = !popupGoal
        ? `${BEST_LABEL} erreicht ✓`
        : popupGoal.kind === 'shipping'
          ? `noch ${popupGoal.at - n} bis ${SHIPPING_LABEL}`
          : `noch ${popupGoal.at - n} bis −${popupGoal.pct} %`;
      goalEl.classList.toggle('is-done', !popupGoal);
      const popupAts = new Set(popupMarks.map(mark => mark.at));
      pips.forEach((pip, i) => {
        pip.classList.toggle('is-filled', i < n);
        pip.classList.toggle('is-milestone', popupAts.has(i + 1));
      });

      crossButtons.forEach(([cand, btn]) => {
        const q = parseInt(itemInput(cand)?.value, 10) || 0;
        btn.textContent = q ? `${q}× in Box` : '+ Hinzufügen';
        btn.classList.toggle('is-added', q > 0);
      });
    };
    popupRefresh();
  }

  function initPopup() {
    if (!el.popup) return;

    // Styles des Pop-ups liegen in einer eigenen Datei neben diesem Skript
    const self = document.querySelector('script[src*="mix-match-redesign.js"]');
    if (self && !document.querySelector('link[data-mmp-css]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = self.src.replace(/mix-match-redesign\.js[^/]*$/, 'mm-product-popup.css');
      link.dataset.mmpCss = '';
      document.head.appendChild(link);
    }

    root.querySelectorAll('.ProductItem__PopUp, .ProductItem__ImageWrapper--withAlternateImage').forEach(trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault();
        openPopup(e.currentTarget.closest('.ProductItem'), e.currentTarget);
      });
    });

    el.popup.addEventListener('click', e => {
      if (e.target === el.popup) closePopup();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && el.popup.getAttribute('aria-hidden') === 'false') closePopup();
    });
  }

  // ── Core: quantity tracking, pricing, ATC ────────────────────────────────
  function initCore() {
    let totalElements = 0;
    const subDefaultAttr = el.subToggle ? el.subToggle.dataset.mmSubDefault : null;
    let isSubscription = subDefaultAttr !== null ? subDefaultAttr !== 'false' : true;
    let selectedFrequencyIndex = '0';
    let isBusy = false;
    const items = {};

    // Cache inputs, prices, and product elements once — avoids repeated DOM queries
    const inputElements  = Array.from(root.querySelectorAll('.CollectionMixAndMatch .QuantitySelector__CurrentQuantity'));
    const priceCache     = new Map();
    const productElCache = new Map();

    inputElements.forEach(input => {
      const { sku } = input.dataset;
      priceCache.set(sku, Number(input.closest('[data-price]')?.dataset.price ?? 0));
      productElCache.set(sku, input.closest('.ProductItem'));
    });

    // Unverändert: muss zur Rabattlogik im Checkout / den Loop Selling Plans passen
    function discountFactor(count) {
      const pct = pricedTiers(isSubscription).reduce((best, tier) => (count >= tier.at ? Math.max(best, tier.pct) : best), 0);
      return 1 - pct / 100;
    }
    // Eine Stufe ab 1 Gericht steht schon auf der Karte. Startet die erste Stufe später, gilt der volle Preis bis dahin.
    function cardFactor(count) {
      const stage1 = pricedTiers(isSubscription)[0];
      const floor = stage1 && stage1.at <= 1 ? 1 - stage1.pct / 100 : 1;
      return Math.min(discountFactor(count), floor);
    }
    const pctAt = count => Math.round((1 - discountFactor(count)) * 100);

    const toEuro = cents => mmMoney(cents);
    const dishes = n => (n === 1 ? mmrText('dish', 'Gericht') : mmrText('dishes', 'Gerichte'));

    // ── Fertige Boxen: Klick füllt den Builder, Preise live wie überall ──
    const presetEls = Array.from(root.querySelectorAll('[data-mmr-preset]')).map((card, index) => {
      let wanted = {};
      try { wanted = JSON.parse(card.dataset.mmrPreset); } catch (err) { console.warn('[MixMatch] Box-Daten ungültig:', err); }
      // nur Gerichte, die auf der Seite tatsächlich wählbar sind
      const qty = {};
      Object.keys(wanted).forEach(sku => { if (priceCache.has(sku)) qty[sku] = Number(wanted[sku]) || 0; });
      // Nur bei der gewählten Box sichtbar (CSS)
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'MMR-Preset__Remove';
      remove.textContent = mmrText('presetRemove', 'Box wieder entfernen');
      card.appendChild(remove);
      return {
        remove,
        card, qty,
        slot: Number(card.dataset.mmrPresetSlot) || index + 1,
        title: card.querySelector('.MMR-Preset__Title')?.textContent.trim() ?? '',
        count: Object.values(qty).reduce((a, q) => a + q, 0),
        total: card.querySelector('[data-mmr-preset-total]'),
        full:  card.querySelector('[data-mmr-preset-full]'),
        badge: card.querySelector('[data-mmr-preset-badge]'),
        btn:   card.querySelector('[data-mmr-preset-pick]'),
      };
    });

    function presetMatchesBox(p) {
      return inputElements.every(input => (parseInt(input.value, 10) || 0) === (p.qty[input.dataset.sku] || 0));
    }

    function updatePresets() {
      presetEls.forEach(p => {
        if (!p.count) { p.card.hidden = true; return; }
        const factor = discountFactor(p.count);
        let full = 0, total = 0;
        Object.entries(p.qty).forEach(([sku, q]) => {
          const price = priceCache.get(sku) ?? 0;
          full  += price * q;
          total += Math.ceil(price * factor) * q;
        });
        const pct = pctAt(p.count);
        if (p.total) p.total.textContent = toEuro(total);
        if (p.full) { p.full.textContent = toEuro(full); p.full.hidden = total >= full; }
        // Hervorgehobene Box: Ersparnis und Preis pro Gericht (Desktop als Chips, Handy als eine Zeile)
        const save = p.card.querySelector('[data-mmr-preset-save]');
        if (save) {
          save.hidden = total >= full;
          if (total < full) {
            save.innerHTML = `<span class="MMR-Preset__Chip">${mmrText('presetSave', 'Du sparst')} ${toEuro(full - total)}</span>`
              + `<span class="MMR-Preset__Chip MMR-Preset__Chip--plain"><span class="MMR-Preset__DeskOnly">nur </span>${toEuro(Math.round(total / p.count))} ${mmrText('presetPerDish', 'pro Gericht')}</span>`;
          }
        }
        if (p.badge) {
          const bestAt = topTier(isSubscription).at;
          p.badge.textContent = pct ? (bestAt > 0 && p.count >= bestAt ? `${BEST_LABEL} −${pct} %` : `−${pct} %`) : '';
          p.badge.hidden = !pct;
          p.badge.classList.toggle('is-best', bestAt > 0 && p.count >= bestAt);
        }
        const chosen = totalElements > 0 && presetMatchesBox(p);
        p.card.classList.toggle('is-chosen', chosen);
        if (p.btn) p.btn.textContent = chosen ? mmrText('presetChosen', 'In deiner Box ✓') : mmrText('presetPick', 'Box übernehmen');
      });
    }

    function clearBox() {
      withSource('clear', () => {
        inputElements.forEach(input => {
          if ((parseInt(input.value, 10) || 0) > 0) {
            input.value = 0;
            syncQuickAddState(input);
          }
        });
      });
    }

    // Für Tracking und Bestellung: Welche Box liegt im Builder, unverändert oder angepasst?
    let lastBox = null;
    function boxState() {
      const exact = totalElements > 0 ? presetEls.find(presetMatchesBox) : null;
      if (exact) return { box_slot: exact.slot, box_title: exact.title, box_status: 'unverändert' };
      if (lastBox) return { box_slot: lastBox.slot, box_title: lastBox.title, box_status: 'geändert' };
      return { box_slot: 0, box_title: 'eigene Box', box_status: 'eigene' };
    }
    const boxLabel = state => (state.box_slot ? `${state.box_title} · ${state.box_status}` : state.box_title);

    function initPresets() {
      presetEls.forEach(p => {
        p.remove.addEventListener('click', () => {
          if (isBusy) return;
          track('mm_box_remove', { box_slot: p.slot, box_title: p.title, count: totalElements });
          clearBox();
          lastBox = null;
        });
        p.btn?.addEventListener('click', () => {
          if (isBusy || presetMatchesBox(p)) { pulseBar(); return; }
          if (totalElements > 0 && !window.confirm(mmrFill(mmrText('confirmReplace', 'Deine aktuelle Box ([count] [dishes]) wird durch „[title]“ ersetzt.'), {
            count: totalElements,
            dishes: dishes(totalElements),
            title: p.card.querySelector('.MMR-Preset__Title')?.textContent.trim() ?? 'diese Box',
          }))) return;
          track('mm_box_pick', { box_slot: p.slot, box_title: p.title, box_size: p.count, replaced: totalElements > 0, count_before: totalElements });
          lastBox = p;
          withSource('box', () => {
            inputElements.forEach(input => {
              const next = p.qty[input.dataset.sku] || 0;
              if ((parseInt(input.value, 10) || 0) !== next) {
                input.value = next;
                syncQuickAddState(input);
              }
            });
          });
          pulseBar();
        });
      });
    }

    // ── Per-card price recalculation ──────────────────────
    let lastFactor = null;

    function updateProductCardPrices(factor) {
      if (factor === lastFactor) return;
      lastFactor = factor;

      root.querySelectorAll('.CollectionMixAndMatch .ProductItem[data-price]').forEach(item => {
        const pricesEl = item.querySelector('.MixAndMatch-ProductItem--Prices');
        if (!pricesEl) return;

        const price     = parseInt(item.dataset.price, 10) || 0;
        const compareAt = parseInt(item.dataset.compareAtPrice, 10) || 0;

        let oldEl  = pricesEl.querySelector('.MixAndMatch-ProductItem--OldPrice');
        const newEl = pricesEl.querySelector('.MixAndMatch-ProductItem--Price');
        if (!newEl) return;

        if (factor < 1) {
          if (!oldEl) {
            oldEl = document.createElement('span');
            oldEl.className = 'MixAndMatch-ProductItem--OldPrice';
            pricesEl.insertBefore(oldEl, newEl);
          }
          oldEl.textContent = toEuro(price);
          oldEl.hidden = false;
          newEl.textContent = toEuro(Math.ceil(price * factor));
        } else {
          newEl.textContent = toEuro(price);
          if (oldEl) {
            if (compareAt > price) {
              oldEl.textContent = toEuro(compareAt);
              oldEl.hidden = false;
            } else {
              oldEl.hidden = true;
            }
          }
        }
      });
    }

    // ── Mengen-Abzeichen auf dem Produktbild ──────────────
    function updateCardBadges() {
      inputElements.forEach(input => {
        const item = productElCache.get(input.dataset.sku);
        const wrap = item?.querySelector('.ProductItem__ImageWrapper');
        if (!wrap) return;
        const qty = parseInt(input.value, 10) || 0;
        let badge = wrap.querySelector('.MMR-QtyBadge');
        if (qty > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'MMR-QtyBadge';
            badge.setAttribute('aria-hidden', 'true');
            wrap.appendChild(badge);
          }
          badge.textContent = `${qty}×`;
        } else if (badge) {
          badge.remove();
        }
      });
    }

    const pipEls = [];

    function initProgress() {
      if (!el.pips) return;
      for (let i = 1; i <= MAX_COUNT; i++) {
        const pip = document.createElement('span');
        pip.className = 'MMR-Pip';
        el.pips.appendChild(pip);
        pipEls.push(pip);
      }
    }

    function progressMessage(n) {
      const plan = planOf(isSubscription);
      const marks = barMilestones(isSubscription);
      const top = topTier(isSubscription);
      if (n === 0) {
        return mmrFill(mmrText('msgEmpty', 'Wähle [count] Gerichte für [reward]'), {
          count: plan.shippingAt,
          reward: SHIPPING_LABEL,
        });
      }
      const goal = marks.find(mark => mark.at > n);
      if (!goal) {
        const shipped = plan.shippingAt > 0 && n >= plan.shippingAt;
        if (top.pct && shipped) return `${BEST_LABEL}: −${top.pct} % + ${SHIPPING_LABEL}`;
        if (top.pct) return `${BEST_LABEL}: −${top.pct} %`;
        return SHIPPING_LABEL;
      }
      const prev = [...marks].reverse().find(mark => mark.at <= n);
      const left = goal.at - n;
      const prevIsDiscount = prev && prev.kind === 'discount';
      const goalText = goal.kind === 'discount'
        ? (prevIsDiscount ? `${goal.pct} %` : `${goal.pct} % Rabatt`)
        : goal.label;
      if (!prev) return `Noch <strong>${left} ${dishes(left)}</strong> bis ${goalText}`;
      const prevText = prev.kind === 'discount' ? `${prev.pct} % Rabatt` : prev.label;
      return `${prevText} ${CHECK_SVG} · noch <strong>${left}</strong> bis ${goalText}`;
    }

    function updateProgress(n) {
      const marks = barMilestones(isSubscription);
      const goal = marks.find(mark => mark.at > n);
      const goalAt = goal ? goal.at : 0;
      const markAts = new Set(marks.map(mark => mark.at));
      const topAt = topTier(isSubscription).at;
      pipEls.forEach((pip, i) => {
        const pos = i + 1;
        pip.classList.toggle('is-filled', pos <= n);
        pip.classList.toggle('is-goal', pos === goalAt);
        pip.classList.toggle('is-milestone', markAts.has(pos));
      });

      if (el.marks) {
        el.marks.replaceChildren();
        marks.forEach((mark, index) => {
          const node = document.createElement('span');
          const place = index === 0 ? 'is-start' : index === marks.length - 1 ? 'is-end' : 'is-mid';
          node.className = `MMR-Mark ${place}`;
          if (mark.kind === 'discount' && mark.at === topAt) node.classList.add('is-top');
          node.style.setProperty('--mmr-pos', `${((mark.at - 0.5) / MAX_COUNT) * 100}%`);
          const done = n >= mark.at;
          node.classList.toggle('is-done', done);
          node.classList.toggle('is-goal', mark.at === goalAt);
          node.innerHTML = `${done ? CHECK_SVG : ''}<span>${mark.kind === 'discount' ? `−${mark.pct} %` : mark.label}</span>`;
          el.marks.appendChild(node);
        });
      }

      if (el.message) el.message.innerHTML = progressMessage(n);
      el.progress?.setAttribute('aria-valuemax', String(MAX_COUNT));
      el.progress?.setAttribute('aria-valuenow', String(Math.min(n, MAX_COUNT)));
    }

    // ── Stufen-Kacheln oben ───────────────────────────────
    function updateTiers(n) {
      if (!el.tiers) return;
      const tierEls = Array.from(el.tiers.querySelectorAll('[data-mmr-tier]'));
      const rewardOf = tier => (isSubscription ? tier.dataset.mmrRewardSub : tier.dataset.mmrRewardOnce) || '';
      const isZero = text => {
        const match = String(text).replace(',', '.').match(/-?\d+(?:\.\d+)?/);
        return !!match && Number(match[0]) === 0;
      };
      tierEls.forEach(tier => { tier.hidden = isZero(rewardOf(tier)); });
      const visible = tierEls.filter(tier => !tier.hidden);
      el.tiers.classList.toggle('is-wrap', visible.length > 3);
      let goal = 0;
      visible.forEach(tier => {
        const at = Number(tier.dataset.mmrTier);
        if (at > n && (goal === 0 || at < goal)) goal = at;
      });
      visible.forEach(tier => {
        const at = Number(tier.dataset.mmrTier);
        tier.classList.toggle('is-done', n >= at);
        tier.classList.toggle('is-goal', at === goal);
        const big = tier.querySelector('[data-mmr-tier-big]');
        const reward = rewardOf(tier);
        if (big && reward) big.textContent = reward;
      });
      if (el.tierNote) {
        const note = isSubscription ? el.tierNote.dataset.noteSub : el.tierNote.dataset.noteOnce;
        if (note) el.tierNote.textContent = note;
      }
    }

    // ── Box-Übersicht: gruppiert statt jedes Glas einzeln ─
    function renderLines(factor) {
      if (!el.lines) return;
      const fragment = document.createDocumentFragment();

      inputElements.forEach(input => {
        const qty = parseInt(input.value, 10) || 0;
        if (!qty) return;
        const item = productElCache.get(input.dataset.sku);
        if (!item) return;

        const name = productTitle(item);
        const imgEl = item.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
        const imgSrc = imgEl
          ? (imgEl.currentSrc || (imgEl.dataset.src ? imgEl.dataset.src.replace('{width}', '120') : ''))
          : '';
        const unit = Math.ceil((priceCache.get(input.dataset.sku) ?? 0) * factor);

        const li = document.createElement('li');
        li.className = 'MMR-Line';

        if (imgSrc) {
          const img = document.createElement('img');
          img.src = imgSrc;
          img.alt = '';
          img.className = 'MMR-Line__Img';
          li.appendChild(img);
        }

        const text = document.createElement('div');
        text.className = 'MMR-Line__Text';
        const title = document.createElement('div');
        title.className = 'MMR-Line__Name';
        title.textContent = `${qty}× ${name}`;
        const sum = document.createElement('div');
        sum.className = 'MMR-Line__Sum';
        sum.textContent = toEuro(unit * qty);
        text.append(title, sum);
        li.appendChild(text);

        const minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'MMR-Line__Btn';
        minus.setAttribute('aria-label', `${name}: eins weniger`);
        minus.innerHTML = MINUS_SVG;
        minus.addEventListener('click', () => {
          withSource('sheet', () => {
            input.value = Math.max((parseInt(input.value, 10) || 0) - 1, 0);
            syncQuickAddState(input);
          });
        });

        const plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'MMR-Line__Btn';
        plus.setAttribute('aria-label', `${name}: eins mehr`);
        plus.innerHTML = PLUS_SVG;
        plus.addEventListener('click', () => {
          withSource('sheet', () => {
            input.value = (parseInt(input.value, 10) || 0) + 1;
            syncQuickAddState(input);
          });
        });

        li.append(minus, plus);
        fragment.appendChild(li);
      });

      el.lines.replaceChildren(fragment);
      if (el.empty) el.empty.hidden = totalElements > 0;
    }

    function updateUI() {
      const factor = discountFactor(totalElements);

      // Round per-item price to match Shopify function rounding behavior (ceil per unit)
      const [originalCents, discountedCents] = Object.entries(items).reduce(
        ([orig, disc], [sku, qty]) => {
          const price = priceCache.get(sku) ?? 0;
          return [orig + price * qty, disc + Math.ceil(price * factor) * qty];
        },
        [0, 0]
      );
      const hasItems = totalElements > 0;
      const hasSaving = hasItems && discountedCents < originalCents;

      el.selectedCount.textContent = totalElements;

      if (!isBusy) {
        atcBtn.disabled = !hasItems;
        el.atcLabel.textContent = hasItems ? mmrText('atcReady', 'In den Warenkorb') : mmrText('atcEmpty', 'Wähle dein erstes Gericht');
      }
      el.atcPrice.hidden = !hasItems;
      el.atcTotal.textContent = toEuro(discountedCents);
      el.atcFull.textContent = toEuro(originalCents);
      el.atcFull.hidden = !hasSaving;

      if (el.saving) {
        el.saving.hidden = !hasSaving;
        el.saving.textContent = hasSaving ? mmrFill(mmrText('saving', 'Du sparst [amount] gegenüber dem Einzelpreis'), { amount: toEuro(originalCents - discountedCents) }) : '';
      }

      updateProgress(totalElements);
      updateTiers(totalElements);
      updateProductCardPrices(cardFactor(totalElements));
      updateCardBadges();
      renderLines(factor);
      updatePresets();
      if (popupRefresh) popupRefresh();
    }

    inputElements.forEach(input => {
      const { sku } = input.dataset;
      items[sku] = 0;

      observeInputValue(input, (prev, next) => {
        const delta = (parseInt(next, 10) || 0) - (parseInt(prev, 10) || 0);
        const before = totalElements;
        totalElements += delta;
        items[sku] = parseInt(next, 10) || 0;
        hideError();
        updateUI();
        if (!delta || changeSource === 'cart') return;
        if (['card', 'popup', 'sheet'].includes(changeSource)) {
          track('mm_dish_change', { dish: productTitle(productElCache.get(sku)), sku, qty: items[sku], delta, count: totalElements, via: changeSource, plan: isSubscription ? 'lieferplan' : 'einmalig' });
        }
        barMilestones(isSubscription)
          .filter(mark => before < mark.at && totalElements >= mark.at)
          .forEach(mark => track('mm_tier_reached', { tier_at: mark.at, tier_kind: mark.kind, tier_pct: mark.pct || 0, count: totalElements, via: changeSource, plan: isSubscription ? 'lieferplan' : 'einmalig' }));
      });
    });

    // ── Subscription state helper ─────────────────────────────────────────
    function applySubscriptionState(enabled) {
      isSubscription = enabled;
      if (el.subToggle)     el.subToggle.checked = enabled;
      if (el.subFreqSelect) el.subFreqSelect.hidden = !enabled;
      el.bar?.classList.toggle('is-subscription', enabled);
    }

    // ── Cart sync (AbortController cancels stale in-flight requests) ──────
    let cartSyncController = null;

    async function fetchAndSync() {
      if (cartSyncController) cartSyncController.abort();
      cartSyncController = new AbortController();
      try {
        const cart = await fetch('/cart.js', { signal: cartSyncController.signal }).then(r => r.json());
        syncMm2QuantitiesToPage(cart.items);
      } catch (e) {
        if (e.name !== 'AbortError') console.warn('[MixMatch] cart sync failed', e);
      }
    }

    // Preselect M&M configuration from cart on page load
    function syncMm2QuantitiesToPage(cartItems) {
      const mm2Items = cartItems.filter(i => i.properties && i.properties['_is_mm']);

      // Restore subscription state FIRST — so updateUI uses correct discountFactor
      // Only override if cart has MM2 items (preserve true default when cart is empty)
      if (el.subToggle && mm2Items.length > 0) {
        const subscriptionItem = mm2Items.find(i => i.selling_plan_allocation);
        applySubscriptionState(!!subscriptionItem);

        // Restore frequency selection from cart
        if (subscriptionItem && el.subFreqSelect) {
          const cartSpId = String(subscriptionItem.selling_plan_allocation.selling_plan.id);
          const firstProductEl = productElCache.values().next().value;
          if (firstProductEl) {
            try {
              const plans = JSON.parse(firstProductEl.dataset.spBase || '{}');
              const matchedIndex = Object.entries(plans).find(([, id]) => String(id) === cartSpId)?.[0];
              if (matchedIndex !== undefined) {
                selectedFrequencyIndex = matchedIndex;
                el.subFreqSelect.value = matchedIndex;
              }
            } catch (e) {}
          }
        }
      }

      // Then set quantities — each triggers updateUI with correct isSubscription
      withSource('cart', () => {
        inputElements.forEach(input => {
          const matched = mm2Items.find(i => String(i.variant_id) === String(input.dataset.sku));
          input.value = matched ? matched.quantity : 0;
          syncQuickAddState(input);
        });
      });
    }

    fetchAndSync();

    document.addEventListener('mm2:cart:updated', e => {
      syncMm2QuantitiesToPage(e.detail.items);
    });

    document.addEventListener('theme:loading:end', fetchAndSync);

    // ── Warenkorb: Lade-Zustand, Doppelklick-Schutz, Fehlermeldung ────────
    function showError(message) {
      if (!el.error) return;
      el.error.textContent = message;
      el.error.hidden = false;
    }
    function hideError() {
      if (el.error) el.error.hidden = true;
    }
    function setBusy(busy) {
      isBusy = busy;
      atcBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
      atcBtn.classList.toggle('is-loading', busy);
      if (busy) {
        atcBtn.disabled = true;
        el.atcLabel.textContent = mmrText('atcLoading', 'Wird hinzugefügt …');
      }
    }

    // ── Early Access: Gratis-Artikel ab X Gerichten ─────────────────────────
    // Eigene Position ohne Lieferplan und ohne _mm_*-Merkmale (die Rabattfunktion zählt sie nicht),
    // ein Bestellrabatt-Code zieht den Preis ab. Leere Varianten-ID = aus.
    const GIFT = {
      variant: String(mmrCopy.giftVariant || '').trim(),
      min: mmrNum('giftMin', 18),
      code: mmrText('giftCode', ''),
      label: mmrText('giftLabel', 'Gratis-Gericht (Early Access)'),
      requireEarly: mmrCopy.giftRequireEarly !== false,
      end: mmrText('giftEnd', ''),
    };
    const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

    // Konfiguration für den Warenkorb merken, damit er den Gratis-Artikel auch außerhalb dieser Seite ergänzen kann
    try {
      if (mmrCopy.giftEnabled && /^\d+$/.test(GIFT.variant)) {
        sessionStorage.setItem('mm_early_gift', JSON.stringify({
          variant: GIFT.variant,
          min: GIFT.min,
          code: GIFT.code,
          label: GIFT.label,
          end: GIFT.end,
          requireEarly: GIFT.requireEarly,
          collectionId: String(mmrCopy.collectionId || ''),
        }));
        document.dispatchEvent(new CustomEvent('mm:gift-sync'));
      } else {
        sessionStorage.removeItem('mm_early_gift');
      }
    } catch (e) {}

    function giftActive() {
      if (!mmrCopy.giftEnabled || !/^\d+$/.test(GIFT.variant)) return false;
      if (GIFT.requireEarly) {
        try {
          if (sessionStorage.getItem('early_access_black_week') !== 'true') return false;
        } catch (e) {
          return false;
        }
      }
      const endsAt = GIFT.end ? Date.parse(GIFT.end) : NaN;
      return !(Number.isFinite(endsAt) && Date.now() > endsAt);
    }

    function cartCodes(cart) {
      if (Array.isArray(cart.discount_codes)) return cart.discount_codes.map(d => d.code).filter(Boolean);
      return (cart.cart_level_discount_applications || []).filter(d => d.type === 'discount_code').map(d => d.title).filter(Boolean);
    }

    async function setGiftCode(cart, apply) {
      if (!GIFT.code) return;
      const current = cartCodes(cart);
      const others = current.filter(c => c.toLowerCase() !== GIFT.code.toLowerCase());
      const next = apply ? [...others, GIFT.code] : others;
      if (next.join(',') === current.join(',')) return;
      await fetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ discount: next.join(',') }) });
    }

    async function syncEarlyGift(count, timestamp) {
      let cart = await fetch('/cart.js').then(r => r.json());
      const giftLines = cart.items.filter(item => item.properties && item.properties._mm_gift);
      const wanted = giftActive() && count >= GIFT.min;
      const keep = wanted && giftLines.length === 1 && giftLines[0].quantity === 1 && String(giftLines[0].variant_id) === GIFT.variant;

      if (!keep && giftLines.length) {
        const updates = {};
        giftLines.forEach(item => { updates[item.key] = 0; });
        await fetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ updates }) });
      }

      if (wanted && !keep) {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: JSON_HEADERS,
          body: JSON.stringify({ items: [{ id: parseInt(GIFT.variant, 10), quantity: 1, properties: {
            '_mm_gift': true,
            '_mm_gift_ts': timestamp,
            '__mmGiftCode': GIFT.code,
            '__mmGiftLabel': GIFT.label,
            '__mmGiftMin': GIFT.min,
          } }] }),
        });
        if (!addRes.ok) {
          // z. B. ausverkauft: die Box bleibt trotzdem im Warenkorb
          console.warn('[MixMatch] Gratis-Artikel konnte nicht hinzugefügt werden', addRes.status);
          return;
        }
        track('mm_gift_added', { count, variant: GIFT.variant });
      }

      if (wanted || giftLines.length) {
        cart = await fetch('/cart.js').then(r => r.json());
        await setGiftCode(cart, wanted);
      }
    }

    atcBtn.addEventListener('click', async () => {
      if (isBusy || totalElements === 0) return;
      hideError();
      setBusy(true);

      const mm2Timestamp = Date.now();
      const box = boxState();
      const atcFactor = discountFactor(totalElements);
      const [atcFull, atcValue] = Object.entries(items).reduce(([full, value], [sku, qty]) => {
        const price = priceCache.get(sku) ?? 0;
        return [full + price * qty, value + Math.ceil(price * atcFactor) * qty];
      }, [0, 0]);
      const atcData = {
        ...box,
        count: totalElements,
        lines: Object.values(items).filter(qty => qty > 0).length,
        plan: isSubscription ? 'lieferplan' : 'einmalig',
        frequency: isSubscription ? (el.subFreqSelect?.selectedOptions?.[0]?.textContent.trim() || '') : '',
        value: atcValue / 100,
        full_value: atcFull / 100,
        discount_pct: pctAt(totalElements),
        currency: MM_CURRENCY,
      };
      track('mm_atc', atcData);
      const cartItems = Object.entries(items)
        .filter(([, qty]) => qty > 0)
        .map(([sku, qty]) => {
          const collectionId = mmrCopy.collectionId ? String(mmrCopy.collectionId) : '';
          const item = { id: sku, quantity: qty, properties: { '_is_mm': true, '_mm_timestamp': mm2Timestamp, ...(collectionId ? { '_mm_collection_id': collectionId } : {}), ...(isSubscription ? { '_is_mm_subscription': true } : {}), '_mm_box': boxLabel(box), '_mm_version': VERSION_LABEL } };
          if (isSubscription) {
            const productEl = productElCache.get(sku);
            if (productEl) {
              try {
                const plans = JSON.parse(productEl.dataset.spBase || '{}');
                const sp = plans[selectedFrequencyIndex] ?? Object.values(plans)[0];
                if (sp) item.selling_plan = parseInt(sp, 10);
              } catch (e) {}
            }
          }
          return item;
        });

      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        const oldMm2Keys = {};
        cart.items.forEach(item => {
          if (item.properties && item.properties['_is_mm']) oldMm2Keys[item.key] = 0;
        });

        // Erst die neue Box hinzufügen, dann die alte entfernen – schlägt das Hinzufügen fehl, bleibt der Warenkorb unverändert
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: cartItems }),
        });
        const res = await addRes.json().catch(() => ({}));
        if (!addRes.ok) {
          throw new Error(res.description || res.message || 'Unbekannter Fehler');
        }

        if (Object.keys(oldMm2Keys).length > 0) {
          const updRes = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: oldMm2Keys }),
          });
          if (!updRes.ok) console.warn('[MixMatch] alte Box konnte nicht entfernt werden', updRes.status);
        }

        try {
          await syncEarlyGift(totalElements, mm2Timestamp);
        } catch (giftErr) {
          console.warn('[MixMatch] Gratis-Artikel:', giftErr);
        }

        setBusy(false);
        track('mm_atc_success', atcData);
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        (res.items || []).forEach(item => {
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { variant: item.variant_id, quantity: item.quantity },
          }));
        });
      } catch (err) {
        console.error('[MixMatch] Failed to add items to cart:', err);
        setBusy(false);
        track('mm_error', { ...atcData, message: String(err.message || err).slice(0, 150) });
        showError(mmrFill(mmrText('errorPrefix', 'Das hat leider nicht geklappt: [message] Bitte versuch es noch einmal.'), { message: err.message }));
      } finally {
        updateUI();
      }
    });

    // ── Box auf-/zuklappen ────────────────────────────────────────────────
    function setSheet(open) {
      if (!el.sheet || !el.sheetToggle) return;
      el.sheet.hidden = !open;
      el.sheetToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      el.bar.classList.toggle('is-open', open);
    }
    el.sheetToggle?.addEventListener('click', () => {
      if (el.sheet.hidden) track('mm_sheet_open', { count: totalElements });
      setSheet(el.sheet.hidden);
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && el.sheet && !el.sheet.hidden) setSheet(false);
    });

    // Sichtbares „Schließen“ in der Box-Übersicht; Tippen außerhalb der Leiste schließt ebenfalls
    const sheetTitle = el.sheet?.querySelector('.MMR-Sheet__Title');
    if (sheetTitle) {
      const head = document.createElement('div');
      head.className = 'MMR-Sheet__Head';
      sheetTitle.replaceWith(head);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'MMR-Sheet__Close';
      close.setAttribute('aria-label', 'Box-Übersicht schließen');
      close.innerHTML = 'Schließen <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
      close.addEventListener('click', () => { setSheet(false); el.sheetToggle?.focus({ preventScroll: true }); });
      const clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'MMR-Sheet__Close MMR-Sheet__Clear';
      clear.setAttribute('aria-label', 'Alle Gerichte aus der Box entfernen');
      clear.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>Leeren';
      clear.addEventListener('click', () => {
        if (isBusy || !totalElements) return;
        if (!window.confirm(`Alle ${totalElements} ${dishes(totalElements)} aus deiner Box entfernen?`)) return;
        track('mm_clear', { count: totalElements, ...boxState() });
        clearBox();
        lastBox = null;
        setSheet(false);
      });
      const actions = document.createElement('div');
      actions.className = 'MMR-Sheet__Actions';
      actions.append(clear, close);
      head.append(sheetTitle, actions);
    }
    document.addEventListener('click', e => {
      // composedPath statt contains: die Zeilen werden beim Klick neu gerendert und sind dann nicht mehr im DOM
      if (el.sheet && !el.sheet.hidden && !e.composedPath().includes(el.bar)) setSheet(false);
    });

    // Kurzes Aufleuchten der Leiste, z. B. nach „Box übernehmen“
    function pulseBar() {
      if (!el.bar) return;
      el.bar.classList.remove('is-pulse');
      void el.bar.offsetWidth;
      el.bar.classList.add('is-pulse');
    }
    el.bar?.addEventListener('animationend', () => el.bar.classList.remove('is-pulse'));

    function initSubscriptionToggle() {
      if (!el.subToggle) return;

      // Handle browser form-state restoration (back navigation)
      if (el.subToggle.checked) applySubscriptionState(true);

      el.subToggle.addEventListener('change', () => {
        applySubscriptionState(el.subToggle.checked);
        updateUI();
        track('mm_plan_toggle', { enabled: el.subToggle.checked, plan: el.subToggle.checked ? 'lieferplan' : 'einmalig', count: totalElements });
      });

      if (el.subFreqSelect) {
        el.subFreqSelect.addEventListener('change', () => {
          selectedFrequencyIndex = el.subFreqSelect.value;
          track('mm_frequency_change', { frequency: el.subFreqSelect.selectedOptions?.[0]?.textContent.trim() || selectedFrequencyIndex, count: totalElements });
        });
      }
    }

    // Platz unter der Produktliste, damit die Leiste nichts verdeckt
    function reserveBarSpace() {
      if (!el.bar) return;
      const apply = () => root.style.setProperty('--mmr-bar-h', `${el.bar.offsetHeight}px`);
      apply();
      if ('ResizeObserver' in window) new ResizeObserver(apply).observe(el.bar);
    }

    window.addEventListener('resize', scheduleMobileTitleHeights);

    // Schnittstelle für das Produkt-Pop-up
    core = {
      count: () => totalElements,
      price: sku => priceCache.get(sku) ?? 0,
      factor: n => discountFactor(n),
      cardFactor: n => cardFactor(n),
      pct: n => pctAt(n),
      isSub: () => isSubscription,
    };

    initProgress();
    applySubscriptionState(isSubscription);
    updateUI();
    labelQuantityButtons(root);
    initQuantityButtons(root);
    initPopup();
    initSubscriptionToggle();
    initFilters();
    initPresets();
    initMobileTitleHeights();
    reserveBarSpace();
    track('mm_view', { plan: isSubscription ? 'lieferplan' : 'einmalig', boxes: presetEls.filter(p => p.count).length });
  }

  const TITLE_ALIGN_MQ = window.matchMedia('(max-width: 640px)');
  let titleAlignRaf = 0;

  function syncMobileTitleHeights() {
    const cells = Array.from(root.querySelectorAll('.CollectionMixAndMatch .Grid__Cell'));
    cells.forEach(cell => {
      const title = cell.querySelector('.ProductItem__Title');
      if (title) title.style.minHeight = '';
    });

    if (!TITLE_ALIGN_MQ.matches) return;

    const visible = cells.filter(cell => cell.querySelector('.ProductItem') && cell.offsetWidth > 0 && getComputedStyle(cell).display !== 'none');

    for (let i = 0; i < visible.length; i += 2) {
      const pairTitles = visible.slice(i, i + 2)
        .map(cell => cell.querySelector('.ProductItem__Title'))
        .filter(Boolean);
      if (!pairTitles.length) continue;

      const maxHeight = Math.max(...pairTitles.map(title => title.offsetHeight));
      pairTitles.forEach(title => {
        title.style.minHeight = maxHeight + 'px';
      });
    }
  }

  function scheduleMobileTitleHeights() {
    cancelAnimationFrame(titleAlignRaf);
    titleAlignRaf = requestAnimationFrame(syncMobileTitleHeights);
  }

  function initMobileTitleHeights() {
    scheduleMobileTitleHeights();
    TITLE_ALIGN_MQ.addEventListener('change', scheduleMobileTitleHeights);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleMobileTitleHeights);
    }
  }

  function initFilters() {
    const filterBtns = root.querySelectorAll('[data-filter]');

    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        filterBtns.forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        const filter = btn.dataset.filter;
        track('mm_filter', { filter, filter_label: btn.textContent.trim() });
        root.querySelectorAll('.CollectionMixAndMatch .Grid__Cell').forEach(cell => {
          if (cell.hasAttribute('data-mmr-brand')) { cell.hidden = filter !== 'mm_alle'; return; }
          const item = cell.querySelector('.ProductItem');
          if (!item) return;
          const tags = (item.dataset.mmTags || '').split(',').map(t => t.trim());
          cell.style.display = (filter === 'mm_alle' || tags.includes(filter)) ? '' : 'none';
        });
        scheduleMobileTitleHeights();
      });
    });

    // Direktsprung aus Bannern: ?filter=mm_knochenbrühe aktiviert den Filter und scrollt zur Filterleiste
    let wanted = '';
    try { wanted = new URLSearchParams(window.location.search).get('filter') || ''; } catch (e) { wanted = ''; }
    if (wanted) {
      const target = Array.from(filterBtns).find(b => b.dataset.filter === wanted);
      if (target) {
        target.click();
        const bar = target.closest('[data-mm-filter]');
        const jump = () => {
          if (!bar) return;
          if (bar.scrollWidth > bar.clientWidth) bar.scrollLeft = Math.max(0, target.offsetLeft - 16);
          const header = document.querySelector('.Header, #shopify-section-header');
          const offset = (header ? header.getBoundingClientRect().height : 70) + 12;
          if (bar.getBoundingClientRect().top < offset + 40) return;
          window.scrollTo(0, bar.getBoundingClientRect().top + window.pageYOffset - offset);
        };
        // zweimal versuchen: Bilder und Theme-Skripte verschieben die Seite nach dem Laden noch
        const run = () => { setTimeout(jump, 300); setTimeout(jump, 1200); };
        if (document.readyState === 'complete') run();
        else window.addEventListener('load', run, { once: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCore);
  } else {
    initCore();
  }
})();
